import {useEffect, memo} from 'react';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import { css } from '@emotion/react'
import colorPalette from '~/theme/colorPalette.js';

const RenderTextField = ({ type, id, label, input, onKeyUp, disabled, setFieldToBeFocused = () => {}, meta: { active, touched, invalid, error, submitError, dirtySinceLastSubmit }, ...custom }) => {

  return (
    <FormControl fullWidth css={inputWrapper}>
      { label && <InputLabel htmlFor={id}>{label}</InputLabel> }
      <Input
        disabled={disabled}
        type={type}
        id={id} // なぜかコメントアウトしていたが理由を失念.
        placeholder={label}
        error={touched && invalid}
        ref={input => setFieldToBeFocused(input)}
        onKeyUp={onKeyUp}
        {...input} // これがないと入力事項がsubmit時にvaluesに入らない
        {...custom}
        css={styledInput}
        className={touched && (error || (submitError && !dirtySinceLastSubmit)) &&  'active'}
      />
    { touched && (error || (submitError && !dirtySinceLastSubmit)) && <span className="error">{error || submitError}</span> }
    </FormControl>
  );
}

export default RenderTextField;

const inputWrapper = css`
  .active{
    input{
      border: 1.5px solid red !important;
      border-radius: 10px;
    }
  }

`;
const styledInput = css`
  background-color: ${colorPalette.background.lightgray};
  border-radius: 10px;
  input{
    font-size: 1.7rem;
    padding: 10px 14px;
  }
  &:before {
    border-bottom: none;
  }
  &:after {
    border-bottom: none;
  }
`;
